import {
  FaTag,
  FaPercent,
  FaUtensils,
  FaSpa,
  FaPlane,
  FaBuilding,
  FaGem,
  FaShoppingBag,
  FaGift,
  FaDumbbell,
  FaRunning,
  FaCar,
  FaBus,
  FaTaxi,
  FaGraduationCap,
  FaBook,
  FaMusic,
  FaTheaterMasks,
  FaCamera,
  FaGamepad,
  FaHotel,
  FaUmbrellaBeach,
  FaHeartbeat,
  FaClinicMedical,
  FaPills,
  FaLaptop,
  FaMobileAlt,
  FaTools,
  FaBriefcase,
  FaUserTie,
  FaClock,
  FaCreditCard,
  FaShieldAlt,
  FaHeadset,
  FaEllipsisH,
  FaTshirt,
  FaShoePrints,
  FaHatCowboy,
  FaGlasses,
  FaShoppingBasket,
  FaWineBottle,
  FaWineGlassAlt,
  FaCoffee,
  FaHamburger,
  FaPizzaSlice,
  FaBreadSlice,
  FaCarrot,
  FaAppleAlt,
  FaFish,
  FaIceCream,
  FaBirthdayCake,
  FaCookie,
  FaLeaf,
  FaSeedling,
  FaMicrochip,
  FaHeadphones,
  FaTv,
  FaBatteryFull,
  FaDesktop,
  FaKeyboard,
  FaPrint,
  FaMouse,
  FaHdd,
  FaServer,
  FaWifi,
  FaPuzzlePiece,
  FaBaby,
  FaRobot,
  FaDice,
  FaHome,
  FaCouch,
  FaBed,
  FaBath,
  FaChair,
  FaLightbulb,
  FaPaintRoller,
  FaHammer,
  FaWrench,
  FaMagic,
  FaCut,
  FaSprayCan,
  FaMotorcycle,
  FaBicycle,
  FaTruck,
  FaTractor,
  FaShip,
  FaSubway,
  FaTabletAlt,
  FaSimCard,
  FaChargingStation,
  FaRing,
  FaDog,
  FaCat,
  FaPaw,
  FaFeather,
  FaFan,
  FaFire,
  FaSnowflake,
  FaUmbrella,
  FaTree,
  FaSwimmer,
  FaFutbol,
  FaBasketballBall,
  FaTableTennis,
  FaGolfBall,
  FaBiking,
  FaSkiing,
  FaBookOpen,
  FaPen,
  FaChalkboardTeacher,
  FaLanguage,
  FaGuitar,
  FaMicrophone,
  FaFilm,
  FaTicketAlt,
  FaPalette,
  FaBrush,
  FaBaseballBall,
  FaVolleyballBall,
  FaChess,
  FaStar,
  FaCrown,
  FaHeart,
  FaThumbsUp,
  FaBolt,
  FaGlobe,
  FaMapMarkedAlt,
  FaConciergeBell,
  FaStore,
  FaStoreAlt,
  FaWarehouse,
  FaIndustry,
  FaHandshake,
  FaChartLine,
  FaBullhorn,
  FaCameraRetro,
  FaVideo,
  FaPodcast,
  FaNewspaper,
  FaFlask,
  FaAtom,
  FaStethoscope,
  FaTooth,
  FaSyringe,
  FaWheelchair
} from "react-icons/fa";

// Maxula — mapping central des icones de categorie (react-icons/fa, aucune emoji).
// v1.378.0 — pack massif d'icones + nombreux alias FR/EN pour eviter le fallback "autre".
export const ICONS = {
  promotion: FaTag,
  reduction: FaPercent,
  deals: FaTag,
  exclusif: FaGem,
  shopping: FaShoppingBag,
  produits: FaShoppingBag,
  cadeaux: FaGift,
  mode: FaTshirt,
  vetements: FaTshirt,
  clothes: FaTshirt,
  habillement: FaTshirt,
  mode_accessoires: FaTshirt,
  fashion: FaTshirt,
  chaussures: FaShoePrints,
  shoes: FaShoePrints,
  chapeaux: FaHatCowboy,
  lunettes: FaGlasses,
  accessoires: FaGlasses,
  bijoux: FaRing,
  montres: FaGem,
  jewelry: FaRing,
  restaurant: FaUtensils,
  restaurants: FaUtensils,
  cafe: FaCoffee,
  gastronomie: FaUtensils,
  fastfood: FaHamburger,
  pizza: FaPizzaSlice,
  boulangerie: FaBreadSlice,
  patisserie: FaBirthdayCake,
  glaces: FaIceCream,
  boissons: FaWineGlassAlt,
  cafes: FaCoffee,
  alimentation: FaShoppingBasket,
  epicerie: FaShoppingBasket,
  food: FaShoppingBasket,
  fruits: FaAppleAlt,
  legumes: FaCarrot,
  bio: FaLeaf,
  poisson: FaFish,
  vin: FaWineBottle,
  cookies: FaCookie,
  spa: FaSpa,
  beaute: FaSpa,
  bienetre: FaSpa,
  cosmetiques: FaSpa,
  coiffure: FaCut,
  sante: FaHeartbeat,
  clinique: FaClinicMedical,
  pharmacie: FaPills,
  esthetique: FaMagic,
  laser: FaMagic,
  maquillage: FaSprayCan,
  dentaire: FaTooth,
  medecin: FaStethoscope,
  vaccination: FaSyringe,
  handicap: FaWheelchair,
  sport: FaDumbbell,
  fitness: FaDumbbell,
  gym: FaDumbbell,
  running: FaRunning,
  football: FaFutbol,
  basketball: FaBasketballBall,
  tennis: FaTableTennis,
  golf: FaGolfBall,
  velo: FaBiking,
  ski: FaSkiing,
  natation: FaSwimmer,
  baseball: FaBaseballBall,
  volleyball: FaVolleyballBall,
  echecs: FaChess,
  voyage: FaPlane,
  tourisme: FaPlane,
  hotel: FaHotel,
  excursion: FaUmbrellaBeach,
  plage: FaUmbrellaBeach,
  croisiere: FaShip,
  immobilier: FaBuilding,
  logement: FaBuilding,
  maison: FaHome,
  decoration: FaCouch,
  deco: FaCouch,
  meubles: FaChair,
  literie: FaBed,
  salle_de_bain: FaBath,
  eclairage: FaLightbulb,
  jardin: FaSeedling,
  bricolage: FaHammer,
  outillage: FaWrench,
  peinture: FaPaintRoller,
  luxe: FaGem,
  premium: FaGem,
  loisirs: FaTheaterMasks,
  divertissement: FaTheaterMasks,
  musique: FaMusic,
  cinema: FaFilm,
  jeux: FaGamepad,
  photo: FaCamera,
  jouets: FaPuzzlePiece,
  enfants: FaBaby,
  guitare: FaGuitar,
  concert: FaMicrophone,
  spectacle: FaTicketAlt,
  art: FaPalette,
  peinture_art: FaBrush,
  des: FaDice,
  education: FaGraduationCap,
  formation: FaBook,
  cours: FaChalkboardTeacher,
  livres: FaBookOpen,
  langues: FaLanguage,
  ecriture: FaPen,
  science: FaFlask,
  recherche: FaAtom,
  voiture: FaCar,
  location_voiture: FaCar,
  taxi: FaTaxi,
  transport: FaBus,
  moto: FaMotorcycle,
  automobile: FaCar,
  velo_transport: FaBicycle,
  camion: FaTruck,
  tracteur: FaTractor,
  metro: FaSubway,
  bateau: FaShip,
  electronique: FaMicrochip,
  gadgets: FaHeadphones,
  tv: FaTv,
  informatique: FaDesktop,
  bureautique: FaPrint,
  ordinateur: FaDesktop,
  clavier: FaKeyboard,
  souris: FaMouse,
  stockage: FaHdd,
  serveur: FaServer,
  reseau: FaWifi,
  batterie: FaBatteryFull,
  chargeur: FaChargingStation,
  technologie: FaLaptop,
  mobile: FaMobileAlt,
  smartphones: FaMobileAlt,
  tablette: FaTabletAlt,
  simcard: FaSimCard,
  robot: FaRobot,
  services: FaTools,
  business: FaBriefcase,
  professionnel: FaUserTie,
  rendezvous: FaClock,
  boutique: FaStore,
  magasin: FaStoreAlt,
  entrepot: FaWarehouse,
  industrie: FaIndustry,
  partenaire: FaHandshake,
  marketing: FaBullhorn,
  statistiques: FaChartLine,
  presse: FaNewspaper,
  video: FaVideo,
  podcast: FaPodcast,
  photographie: FaCameraRetro,
  animaux: FaPaw,
  chien: FaDog,
  chat: FaCat,
  oiseaux: FaFeather,
  nature: FaTree,
  fleurs: FaSeedling,
  plantes: FaLeaf,
  climatisation: FaFan,
  chauffage: FaFire,
  froid: FaSnowflake,
  meteo: FaUmbrella,
  energie: FaBolt,
  international: FaGlobe,
  localisation: FaMapMarkedAlt,
  conciergerie: FaConciergeBell,
  favoris: FaStar,
  vip: FaCrown,
  coeur: FaHeart,
  populaire: FaThumbsUp,
  paiement: FaCreditCard,
  securite: FaShieldAlt,
  support: FaHeadset,
  autre: FaEllipsisH,
};

export const renderCategoryIcon = (iconKey, size = 44, className = "text-[#e11d7b]") => {
  const key = String(iconKey || "").toLowerCase().trim();
  const Icon = ICONS[key] || ICONS.autre;
  return <Icon size={size} className={className} aria-hidden="true" />;
};
